import * as Card from 'card';
import * as MP from './payments/mercadopago';
import * as PagSeguro from './payments/pagseguro';
import { pageLoadingOff, pageLoadingOn, validateForm } from './utilities';
import * as GooglePay from './payments/googlepay';

const alertPaymentUnavailable = (message, callback = null) => {
  setTimeout(() => {
    alert(message);
    if (typeof callback === 'function') callback();
  }, 500);
}

const loadAnimatedCard = (form) => {
  const formSelector = `form#${form.getAttribute('id')}`;
  const containerSelector = `div.card-wrapper.gateway${form.getAttribute('data-paymentId')}`;
  new Card({
    form: formSelector,
    container: containerSelector,
    formSelectors: {
      numberInput: formSelector+' input#cardNumber',
      expiryInput: formSelector+' input#cardExpirationDate',
      cvcInput: formSelector+' input#cardSecurityCode',
      nameInput: formSelector+' input#cardHolderName'
    },
    placeholders: {
      number: '**** **** **** ****',
      name: 'NOME IDENTIFICADOR',
      expiry: '**/**',
      cvc: '123'
    },
    width: 250,
    formatting: true,
  });

  document.addEventListener("card-type-changed", e => {
    const cardBrandInput = form.querySelector("input#cardBrand");
    if (cardBrandInput && e.detail !== "unknown") {
      cardBrandInput.value = e.detail;
    }
  });
}

const getGoogleRecaptchaV3Token = (form) => {
  const recaptchaInput = form.querySelector("input#googleRecaptcha");
  if (!recaptchaInput) {
    return Promise.reject("Missing recaptcha input");
  }
  const site_key = recaptchaInput.getAttribute('data-sitekey');
  const action = recaptchaInput.getAttribute('data-action');
  if (!site_key || !action) {
    return Promise.reject("Missing sitekey or data-action");
  }
  return grecaptcha.execute(site_key, { action })
    .then(token => {
      recaptchaInput.value = token;
    })
}

/**
 * 
 * @param {HTMLFormElement} form 
 * @param {(form) => Promise<void>} callback 
 */
const bindSubmitButton = (form, callback = null) => {
  form.querySelector('button#payment-submit-button').addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    pageLoadingOn();
    if (!validateForm($(form))) {
      pageLoadingOff();
      return;
    }

    if (typeof callback === "function") {
      getGoogleRecaptchaV3Token(form)
      .then(() => callback(form))
      .then(() => form.submit())
      .catch(() => {
        alertPaymentUnavailable("Não é possível finalizar o pagamento no momento", pageLoadingOff);
      });
    } else {
      getGoogleRecaptchaV3Token(form)
      .then(() => form.submit())
      .catch(() => {
        alertPaymentUnavailable("Não é possível finalizar o pagamento no momento", pageLoadingOff);
      });
    }
  });
}

export const loadCardForms = () => {
  const forms = document.querySelectorAll("form.form-payment-gateway-card");
  forms.forEach(form => {
    loadAnimatedCard(form);
    switch (form.getAttribute('data-gateway')) {
      case '20':
        MP.setInstallments(form);
        bindSubmitButton(form, MP.submitForm);
      break;

      case '25':
        bindSubmitButton(form, PagSeguro.submitForm);
      break;
    
      default: bindSubmitButton(form); break;
    }
  });

  
}
/**
 * 
 * @param { number } total Valor total da compra
 */
export const loadWallets = (total) => {
  const googlePayContainer = document.querySelector(".form-payment-wallet[data-class=google-pay]");
  if (googlePayContainer) {
    const isSandbox = location.hostname.includes('mkx.net') ? true : false; 
    GooglePay.GooglePayHandler.totalPrice = total;
    const googlePayHandler = new GooglePay.GooglePayHandler(
      googlePayContainer,
      googlePayContainer.getAttribute('data-paymentId'),
      googlePayContainer.getAttribute('data-gatewayId'),
      googlePayContainer.getAttribute('data-paymentType'),
      'BCR2DN4T4OIJFQSU',
      { 
        environment: isSandbox ? 'TEST' : 'PRODUCTION',
        gatewayMerchantId: isSandbox ? '6b206a5d-efad-45ea-be98-2c078b2c7bba' : 'c15a7291-0b05-4287-9db6-c657bc6262ac'
      }
    );
    GooglePay.init(googlePayHandler);
  }
}